import { Suspense, useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Outlet, useBlocker, useLocation } from "react-router-dom";

import { SpinnerLoader } from "components/loader/loader";
import { useVersionCheck } from "hooks/use-version-check";
import { getPageMetadata, trackEvent } from "utils";

export const Main = () => {
  const location = useLocation();
  const { shouldBlock, checkVersion } = useVersionCheck();

  const blocker = useBlocker(() => shouldBlock());
  useEffect(() => {
    if (blocker.state !== "blocked") return;
    const handleVersionCheck = async () => {
      const stale = await checkVersion();
      if (stale) {
        const { pathname, search, hash } = blocker.location;
        window.location.href = pathname + search + hash;
      } else {
        blocker.proceed();
      }
    };
    handleVersionCheck();
  }, [blocker, checkVersion]);

  useEffect(() => {
    trackEvent("page_view", {
      path: location.pathname,
      query: location.search.slice(1),
    });
  }, [location]);

  const pageMetadata = getPageMetadata(location.pathname);
  return (
    <HelmetProvider>
      <Suspense fallback={<SpinnerLoader />}>
        <Helmet title={pageMetadata.title}>
          <meta
            property="og:title"
            itemProp="name"
            content={pageMetadata.title}
          />
          <meta
            property="og:url"
            itemProp="url"
            content={window.location.href}
          />
          <meta
            name="description"
            itemProp="description"
            property="og:description"
            content={
              pageMetadata?.description ??
              "SageSure is the trusted expert for homeowners insurance in the most challenged areas of coastal states."
            }
          />
        </Helmet>
        <div>
          <Outlet />
        </div>
      </Suspense>
    </HelmetProvider>
  );
};
